import { mcpEmbedConfig } from "./mcp-embed.config";

export const MCP_EMBED_HISTORY_KEY = "mangoMcpEmbed";

// Presence selects the guarded flow; validity is checked by McpEmbedService.
// Generic screen/displayId parameters are also used by ordinary application URLs.
export function hasMcpEmbedLaunch(url: URL): boolean {
  return (
    ["mcpTransport", "mcpLoadId", "mcpRefresh", "hostOrigin"].some((key) =>
      url.searchParams.has(key),
    ) || new URLSearchParams(url.hash.slice(1)).has("handoff")
  );
}

// Capture before handoff cleanup and routing. History state belongs to this
// frame's entry, so a reload stays guarded without marking sibling portal frames.
// This flag is context only; it never replaces handoff/session authentication.
const embedded =
  mcpEmbedConfig.enabled &&
  (hasMcpEmbedLaunch(new URL(window.location.href)) ||
    history.state?.[MCP_EMBED_HISTORY_KEY] === true);

export function isMcpEmbeddedWindow(): boolean {
  return embedded;
}

export function rememberMcpEmbedContext(): void {
  if (embedded && history.state?.[MCP_EMBED_HISTORY_KEY] !== true) {
    history.replaceState(
      { ...history.state, [MCP_EMBED_HISTORY_KEY]: true },
      "",
    );
  }
}

export function applyMcpEmbedPresentation(embedded: boolean): void {
  document.body.classList.toggle("mango-chat-embed", embedded);
}

export function mcpSupportChatEnabled(): boolean {
  return !isMcpEmbeddedWindow();
}

export function bootMangoSupportChat(
  intercom: { boot: (data: any) => void },
  data: any,
): void {
  if (mcpSupportChatEnabled()) {
    intercom.boot(data);
  }
}
